<template>
  <div class="">
    <div
      class="f-flex f-flex-betweent nav-box"
      :class="{ isProductList: isproductlist }"
    >
      <div>
        <router-link to="/" class="f-flex f-flex-center">
          <img src="../../../static/images/heardLogo.png" alt="" />
          <span class="title">时尚知识产权保护中心</span>
        </router-link>
      </div>
      <div>
        <div class="userinfo f-flex f-flex-center pinter" @click="showuserinfo">
          <img src="../../../static/images/usericon_1.png" alt="" />
          <!-- <i class="iconfont icon-zhankaixiao"></i> -->
        </div>
      </div>
    </div>
    <div style="background: #f6f6fd">
      <div class="safe-contain block-center">
        <div class="searchBox" v-if="showsearch">
          <div class="searchinner f-flex f-flex-rowcenter">
            <div
              class="f-flex f-flex-rowcenter left-search"
              @click="selectVisible = true"
            >
              <i class="iconfont icon-a-sousuo2 searchicon"></i>
              <span class="">{{
                searchTypeActive === "power" ? "按系列" : "按证物"
              }}</span>
              <i class="iconfont icon-zhankaixiao searchdown"></i>
              <div class="typeselect" :class="{ show: selectVisible }">
                <ul>
                  <li
                    :key="index"
                    v-for="(item, index) in searchType"
                    @click.stop.prevent="selectclick(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <input
              type="text"
              v-model="searchValue"
              :placeholder="`搜索我创建的${
                searchTypeActive === 'power' ? '系列' : '证物袋'
              }`"
              class="searchinput"
            />
            <span class="f-btn inputsearchbtn" @click="search">搜索</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isproductlist: false,
      showsearch: true,
      selectVisible: false,
      searchValue: '',
      searchTypeActive: 'power',
      searchType: [
        {
          name: '按系列',
          key: 'power'
        },
        {
          name: '按证物',
          key: 'tort'
        }
      ]
    };
  },
  methods: {
    selectclick(item) {
      this.searchTypeActive = item.key;
      this.selectVisible = false;
    },
    showuserinfo() {
      this.$bus.$emit('showinfo', 1);
    },
    search() {
      if (this.searchValue !== '') {
        let routerData = this.$router.resolve({
          path: '/protectCenter',
          query: {
            type: this.searchTypeActive,
            searchText: this.searchValue
          }
        });
        window.open(routerData.href, '_blank');
      }
    }
  },
  watch: {
    '$route': {
      handler: function (value) {
        this.searchValue = value.query.searchText || '';
        this.searchTypeActive = value.query.type || 'power';
        if (value.path === '/productList' || value.path === '/vipIndex' || value.path === '/noticePage' ||
          value.path === '/introduction' || value.path === '/issue' || value.path === '/charge' || value.path === '/dilatation' || value.path === '/pay' || value.path === '/safeguard') {
          this.isproductlist = true;
          this.showsearch = false;
        }
        if (value.query.No) {
          this.showsearch = false;
        }
      },
      immediate: true

    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin-left: 16px;
  font-size: 12px;
  color: #999;
  letter-spacing: 0.28em;
}
.userinfo {
  i {
    font-size: 12px;
    transform: scale(0.8);
    color: #737373;
    margin-left: 8px;
  }
}
.nav-box {
  padding: 0px 24px;
  height: 56px;
  &.isProductList {
    background: #f2f2f2;
  }
  .searchinput {
    font-size: 16px;
    outline: none;
    border: 1px solid #ddd;
    background: #edf2f5;
    height: 40px;
    padding: 0px 20px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/heard/index.vue